
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widget/[type]",
      function () {
        return require("private-next-pages/widget/[type].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/widget/[type]"])
      });
    }
  